import React, { useMemo } from "react";
import t from "../../i18n/translate";
import {
    ItemDetails,
    ItemName,
    ItemPrice,
    ItemSize,
    ItemWrapper
} from "../../containers/Profile/Order/Order.style";

const OrderTableColumns = () => {
    const columns = useMemo(() => {
        return [
            {
                title: t('home_basket_items_label', false),
                dataIndex: "",
                key: "items",
                width: 250,
                ellipsis: true,
                render: (text, record) => {
	                // Use backend display flags (all logic handled in API)
	                const isCancelled = record.should_strikethrough || false;
	                const isGreyedOut = record.should_grey_out || false;
	                const isIndented = record.should_indent || false;
	                const statusText = record.status_text;
	                const commentText = record.comment_text;
	                const displayPrice = record.display_unit_price || parseFloat(record.item_price).toFixed(2);

                    return (
	                    <ItemWrapper style={{
		                    backgroundColor: isCancelled ? '#f5f5f5' : 'transparent',
		                    opacity: isCancelled ? 0.7 : 1,
		                    padding: '8px 0'
	                    }}>
                            <ItemDetails>
	                            {/* Item name with indent for replacements (matches PDF) */}
	                            <ItemName style={{
		                            textDecoration: isCancelled ? 'line-through' : 'none',
		                            color: isGreyedOut ? '#999' : 'inherit',
		                            paddingLeft: isIndented ? '20px' : '0'
	                            }}>
		                            {record.item_name}
	                            </ItemName>

	                            {/* Status label in grey (matches PDF exactly) */}
	                            {isCancelled && (
		                            <div style={{
			                            color: '#999',
			                            fontSize: '11px',
			                            display: 'block',
			                            paddingLeft: isIndented ? '20px' : '0',
			                            marginTop: '2px'
		                            }}>
			                            (Cancelled)
		                            </div>
	                            )}

	                            {/* Comment in grey if cancelled (matches PDF) */}
	                            {commentText && (
		                            <div style={{
			                            color: '#999',
			                            fontSize: '11px',
			                            display: 'block',
			                            paddingLeft: isIndented ? '20px' : '0',
			                            marginTop: '2px'
		                            }}>
			                            {commentText}
		                            </div>
	                            )}

	                            <ItemSize style={{
		                            paddingLeft: isIndented ? '20px' : '0',
		                            color: isGreyedOut ? '#999' : 'inherit',
		                            textDecoration: isCancelled ? 'line-through' : 'none',
		                            marginTop: '4px'
	                            }}>
                                    {record.weight != null
                                        ? record.weight + " " + (record.weight_unit != null ? record.weight_unit : "")
                                        : record.item_price_name}
                                </ItemSize>
	                            <ItemPrice className="item-price" style={{
		                            paddingLeft: isIndented ? '20px' : '0',
		                            color: isGreyedOut ? '#999' : 'inherit',
		                            textDecoration: isCancelled ? 'line-through' : 'none'
	                            }}>
		                            ${displayPrice}
	                            </ItemPrice>
                            </ItemDetails>
                        </ItemWrapper>
                    );
                },
            },
            {
                title: t('shop_order_list_quantity_label', false),
                dataIndex: "quantity",
                key: "quantity",
                align: "center",
                width: 100,
                render: (text, record) => {
	                // Use backend display flags (matches PDF exactly)
	                const isCancelled = record.should_strikethrough || false;
	                const isGreyedOut = record.should_grey_out || false;
	                const displayQty = record.display_quantity !== undefined ? record.display_quantity : record.quantity;
	                return <p style={{
		                color: isGreyedOut ? '#999' : 'inherit',
		                textDecoration: isCancelled ? 'line-through' : 'none',
		                margin: 0
	                }}>{displayQty}</p>;
                },
            },
            {
                title: t('shop_order_list_price_label', false),
                dataIndex: "",
                key: "price",
                align: "right",
                width: 100,
                render: (text, record) => {
	                // Use backend display flags and calculated values (matches PDF exactly)
	                const isCancelled = record.should_strikethrough || false;
	                const isGreyedOut = record.should_grey_out || false;
	                const displayTotal = record.display_total || (parseFloat(record.quantity * record.item_price).toFixed(2));
	                return (
		                <p style={{
			                color: isGreyedOut ? '#999' : 'inherit',
			                textDecoration: isCancelled ? 'line-through' : 'none',
			                margin: 0
		                }}>
			                ${displayTotal}
		                </p>
	                );
                },
            },
        ];
    }, []); // Add any dependencies here if needed

    return columns;
};

export default OrderTableColumns;